import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { HTMLAttributes } from 'react';

import { Body, Icon } from '@growtherapy/sprout-ui';

import { FormType, GroupedFormData } from '../types';
import { FormListItemBadge } from './FormListItemBadge';
import { FormListItemContent } from './FormListItemContent';
import { FormListItemLayout } from './FormListItemLayout';
import { FormListItemBadgeVariant } from './types';

type FormListItemProps = {
  form: GroupedFormData;
  onClick: HTMLAttributes<HTMLButtonElement>['onClick'];
};

function getFormTitle(form: GroupedFormData) {
  return form.formType === FormType.Gad7 || form.formType === FormType.Phq9
    ? `${form.formType} - ${form.formTitle}`
    : form.formTitle;
}

const SCORED_FORM_TYPES: FormType[] = [FormType.Gad7, FormType.Phq9];

export function FormListItem({ form, onClick }: FormListItemProps) {
  const isScored = SCORED_FORM_TYPES.includes(form.formType as FormType);
  return (
    <FormListItemLayout buttonProps={{ onClick }}>
      <FormListItemBadge
        className={{
          'px-8 py-4': !isScored,
        }}
        variant={form.highAcuity ? FormListItemBadgeVariant.High : FormListItemBadgeVariant.Low}
      >
        {' '}
        <div className='flex-row text-center leading-tight'>
          {isScored ? (
            <div className='pb-1 font-medium'>{form.score?.toString()}</div>
          ) : (
            <Icon aria-hidden={false} aria-label='Completed' icon={faCheck} />
          )}
        </div>
      </FormListItemBadge>
      <FormListItemContent
        title={
          <Body.Default as='span' className='block text-text-inverse'>
            {getFormTitle(form)}
          </Body.Default>
        }
        subtitle={
          form.createdAt && (
            <Body.Small as='span' className='text-text-inverse'>
              Submitted {form.createdAt}
            </Body.Small>
          )
        }
      />
    </FormListItemLayout>
  );
}
